import React from "react";
import "./Pricing.css";
import RotatingPricingSection from "./RotatingPricingSection";
import { Helmet } from "react-helmet-async";

function Pricing() {
  return (
    <>
      <Helmet>
        <title>
        IzzyAI Plans — IzzyAI.com
        </title>
        <meta name="description"
          content="Find out the cost of registering a domain in our pricing table. Get 24/7 support."
        />
      </Helmet>
      <div className="pricing-div ">
        <div className="section over-hide flex justify-center items-center ">
          <RotatingPricingSection  />
        </div>
      </div>
    </>
  );
}

export default Pricing;
